import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';

import { VaiController, UmiVault, DlVault } from 'types/contracts';

export interface IsetOutRoiInput {
  dlControllerContract: DlVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type IsetOutRoiOutput = TransactionReceipt;

const setOutRoi = async ({
  dlControllerContract,
  fromAccountAddress,
  amountWei,
}: IsetOutRoiInput): Promise<IsetOutRoiOutput> => {
  const resp = await dlControllerContract.methods
    .setOutRoi(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setOutRoi;
